import { render } from "./RiskAlertCenter.vue?vue&type=template&id=46117880&scoped=true"
import script from "./RiskAlertCenter.vue?vue&type=script&lang=js"
export * from "./RiskAlertCenter.vue?vue&type=script&lang=js"

import "./RiskAlertCenter.vue?vue&type=style&index=0&id=46117880&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46117880"]])

export default __exports__